import angular from 'angular';

var iconsMap = {
  autorenew: '/assets/img/global/autorenew.png',
};

class IconController {
  static $inject = ['$element'];
  iconsMap = iconsMap;
  name = '';

  constructor(private $element: JQuery) {}

  $onInit() {
    this.$element.addClass('acme-icon');

    if (!this.name) {
      throw new Error('acmeIcon.name is required');
    }
  }

  $onChanges() {
    this.setBackgroundImage();
  }

  private setBackgroundImage() {
    this.$element[0].style.setProperty('--background-image', `url(${this.iconsMap[this.name]})`);
  }
}

export const IconComponentModule = angular.module('acme.common.component.icon', []).component('acmeIcon', {
  templateUrl: 'common/components/icon/icon.component.tpl.html',
  controller: IconController,
  bindings: {
    name: '<',
  },
}).name;
